import { lang } from "i18nLang";

export class MaximumAttachmentsException extends Error {
  constructor() {
    super(lang("attachments.errors.maximumFilesCount"));
    this.name = "MaximumAttachmentsException";
  }
}

export class InvalidAttachmentFormatException extends Error {
  constructor() {
    super(lang("attachments.errors.invalidFormat"));
    this.name = "InvalidAttachmentFormatException";
  }
}

export class MaximumAttachmentSizeException extends Error {
  constructor() {
    super(lang("attachments.errors.maximumSize"));
    this.name = "MaximumAttachmentSizeException";
  }
}

export class InvalidAttachmentException extends Error {
  constructor() {
    super(lang("attachments.errors.invalidFile"));
    this.name = "InvalidAttachmentException";
  }
}
